import React, {useEffect, useMemo, useState} from "react";
import {playlistService} from "../../../services/playlistsService/playlistService";
import {toast} from "react-toastify";
import {Modal} from "react-bootstrap";
import ModalClose from "../../../assets/modal_close.png";
import Button from "react-bootstrap/Button";

const AddPlaylistModal = ({ onClose, onCreated, onUpdated, playlist = null }) => {
    const isEdit = Boolean(playlist?.id);

    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState("");

    useEffect(() => {
        setName(playlist?.name ?? "");
    }, [playlist]);

    const handleClose = () => onClose && onClose();

    const handleChange = (e) => setName(e.target.value);

    const trimmedName = useMemo(() => name.trim(), [name]);

    const isDisabled = useMemo(() => {
        if (isLoading) return true;
        if (!trimmedName) return true;
        if (isEdit && trimmedName === (playlist?.name ?? "").trim()) return true;
        return false;
    }, [isLoading, trimmedName, isEdit, playlist]);

    const handleSubmit = async () => {
        if (isDisabled) return;
        setIsLoading(true);
        try {
            if (isEdit) {
                const updated = await playlistService.updatePlaylist({ name: trimmedName }, playlist.id);
                onUpdated && onUpdated(updated.data);
                toast.success("Playlist updated successfully.");
            } else {
                const created = await playlistService.createPlaylist(trimmedName);
                onCreated && onCreated(created.data);
                toast.success("Playlist created successfully.");
            }
            onClose && onClose();
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <Modal
            onHide={handleClose}
            centered
            show={true}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header className="modal-header m-0">
                <div className="question">{isEdit ? "Edit Playlist" : "Create new Playlist"}</div>
                <div className="modal-close" onClick={handleClose} role="button" aria-label="Close">
                    <img src={ModalClose} alt="Close" />
                </div>
            </Modal.Header>

            <Modal.Body style={{ maxHeight: "450px", overflowY: "scroll" }}>
                <div className="mt-3 px-3">
                    <input
                        id="playlist-name"
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="Name"
                        value={name}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        autoComplete="off"
                        autoFocus
                    />
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    className="btn btn-primary add-btn"
                    onClick={handleSubmit}
                    disabled={isDisabled}
                >
                    {isEdit ? "Save" : "Create"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddPlaylistModal;